import axios from "axios";
import { safeGet } from "../utils/safeStorage";

export const config = {
  baseURL: `${process.env.REACT_APP_DOMAIN_URL}/api`,
  CalendlyUrl: "https://calendly.com/eedoubleone",
};

const client = axios.create({
  baseURL: config.baseURL,
  timeout: 100000,
  headers: {
    common: {
      "ngrok-skip-browser-warning": true,
      Accept: "*/*",
      "Content-Type": "application/json",
    },
  },
});

// Always attach the auth token from localStorage on every request
client.interceptors.request.use((cfg) => {
  const token = safeGet("nd-rest-tkn");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

export default client;
